// extracted by mini-css-extract-plugin
export default {"inputWrapper":"NameInput_inputWrapper__phbFB","label":"NameInput_label__L0DXZ","error":"NameInput_error__jlaZB","input":"NameInput_input__9EMbe"};